import { useEffect, useState } from 'react';
import { SLOW_NETWORK_MS } from '@constants/timing';

/**
 * True once `active` (a load, a send) has run for `ms` without finishing: the screen then says the connection is slow
 * and that it keeps trying, instead of a spinner that looks stuck. False again as soon as it ends.
 */
export function useSlow(active: boolean, ms: number = SLOW_NETWORK_MS) {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    if (!active) {
      setSlow(false);
      return;
    }
    const t = window.setTimeout(() => setSlow(true), ms);
    return () => window.clearTimeout(t);
  }, [active, ms]);
  return slow;
}
